import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const OutlineMessageIcon = (props) => {
    return (
        <SvgIcon {...props} style={{ fill: 'none', stroke: 'var(--primary)', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px'}} viewBox="0 0 63.362 49.124" fontSize="xxLarge">
          <path
                d="M3,15.1,29.56,32.8a6.732,6.732,0,0,0,7.469,0L63.589,15.1M9.732,52.124H56.857a6.732,6.732,0,0,0,6.732-6.732V11.732A6.732,6.732,0,0,0,56.857,5H9.732A6.732,6.732,0,0,0,3,11.732v33.66A6.732,6.732,0,0,0,9.732,52.124Z"
                transform="translate(-1.613 -4)"/>
        </SvgIcon>
    );
};

export default OutlineMessageIcon;
